import script from "./sw-item-editor-multi-select.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-multi-select.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-multi-select.vue?vue&type=style&index=0&id=32042dde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32042dde"]])

export default __exports__